import { useEffect, useState } from "react";
import api from "../utils/api";
import RelatedVideoCard from "./RelatedVideoCard";

const GUEST_USER_ID = "000000000000000000000000";

export default function RelatedVideosList({ videoId }) {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!videoId) return;

    let mounted = true;

    const fetchRelated = async () => {
      try {
        setLoading(true);

        const res = await api.get("/client/video/getAllLikeThis", {
          params: {
            userId: GUEST_USER_ID,
            videoId,
            videoType: 1, // normal video
          },
        });

        if (mounted && res.data?.status && Array.isArray(res.data?.data)) {
          setVideos(res.data.data);
        } else if (mounted) {
          setVideos([]);
        }
      } catch (err) {
        console.error("Related videos error:", err);
        if (mounted) setVideos([]);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchRelated();

    return () => {
      mounted = false;
    };
  }, [videoId]);

  /* ===============================
     UI STATES
  =============================== */

  if (loading) {
    return (
      <div style={{ fontSize: 14, color: "#666" }}>
        Loading related videos...
      </div>
    );
  }

  if (!videos.length) {
    return null; // YouTube bhi empty me kuchh nahi dikhata
  }

  /* ===============================
     UI
  =============================== */

  return (
    <div style={{ marginTop: 24 }}>
      <h4 style={{ marginBottom: 12 }}>Related Videos</h4>

      {videos.map((video) => (
        <RelatedVideoCard key={video._id} video={video} />
      ))}
    </div>
  );
}
